import contactsDictionary from '@pages/contacts/i18n/ru/contacts.dic.json';

export const contacts = {
  CONTACTS: contactsDictionary,
};

export const contactsNamespaces = ['CONTACTS'];
